import { api } from '../../../api';
import { ApiResponse } from '../../Utilities';
import { AddressViewModel, CountryCodeViewModel } from '../../ViewModels';

export class CommonApi {
    private route = '/Common';

    public getGeocode({
        params,
    }: {
        params: { buyerCompanyId: number; address: string };
    }): ApiResponse<AddressViewModel> {
        return api().get(`${this.route}/Geocode`, { params });
    }

    /**
     * Retrieves a list of countries, sorted by index by default.
     */
    public getCountry({
        params = { $orderby: 'SortIndex ASC' },
    }: {
        params?: {
            $orderby?: string;
        };
    }): ApiResponse<CountryCodeViewModel[]> {
        return api().get(`${this.route}/Country`, { params });
    }
}
